/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hx-small-font-metric[_ngcontent-%COMP%]{font-size:20px}"];
export { styles as styles };
